export class CustomerBuilder {
    constructor() {
        this.properties = {};
    }
    withAddress(address) {
        this.properties.address = address;
        this.properties.name = address.name;
        this.properties.givenName = address.givenName;
        this.properties.surname = address.surname;
        return this;
    }
    withPersonalNumber(personalNumber) {
        this.properties.personalNumber = personalNumber;
        return this;
    }
    withEmail(email) {
        this.properties.email = email;
        return this;
    }
    withPhoneNumber(phoneNumber) {
        this.properties.phoneNumber = phoneNumber;
        return this;
    }
    withGivenName(givenName) {
        this.properties.givenName = givenName;
        return this;
    }
    withSurname(surname) {
        this.properties.surname = surname;
        return this;
    }
    build() {
        return this.properties;
    }
}
